import classNames from 'classnames';
import React from 'react';
import { ScrollableBody } from '../../components/Layout/ScrollableBody';
import { CTAButton } from '../ButtonBase/index';
import css from './OptionBoxes.module.scss';

export interface IProps {
    primaryText: string | JSX.Element;
    primaryButtonText: string;
    onPrimaryClick: () => void;
}

export const SingleOptionBox: React.FC<IProps> = React.memo((props) => (
    <ScrollableBody>
        <div className={css.optionBoxes}>
            <div className={css.growBox}>
                <div className={classNames(css.box, css.primary, typeof props.primaryText === 'string' ? css.text : '')}>
                    <span>{props.primaryText}</span>
                </div>
                <div className={classNames(css.box)}>
                    <CTAButton
                        styleType={'primary'}
                        onClick={() => {
                            props.onPrimaryClick();
                        }}
                        label={props.primaryButtonText}
                        id={props.primaryButtonText}
                        ariaLabel={props.primaryButtonText}
                    />
                </div>
            </div>
        </div>
    </ScrollableBody>
));

export { SingleOptionBox as default };
